export const WORKER_CODE = [
  '"use strict";',
  'function computeShannonEntropy(chroma) {',
  '  var entropy = 0; var sum = chroma.reduce(function(a, b){ return a + b; }, 0) || 1;',
  '  for (var i=0; i<chroma.length; i++) { var p = chroma[i] / sum; if (p > 0.001) entropy -= p * Math.log2(p); }',
  '  return entropy / 3.58;',
  '}',
  'function calculateStability(onsets) {',
  '  if (onsets.length < 3) return 0.5; var intervals = [];',
  '  for (var i = 1; i < onsets.length; i++) { var d = onsets[i] - onsets[i - 1]; if(d > 0) intervals.push(d); }',
  '  if (intervals.length === 0) return 0.5;',
  '  var mean = intervals.reduce(function(a, b){ return a + b; }, 0) / intervals.length;',
  '  var variance = intervals.reduce(function(a, b){ return a + Math.pow(b - mean, 2); }, 0) / intervals.length;',
  '  var cv = Math.sqrt(variance) / (mean || 1); return Math.max(0, Math.min(1, 1 - cv));',
  '}',
  'function detectOnsets(data, sr) {',
  '  var onsets = []; var hop = 256; var win = 512; var energies = [];',
  '  for (var i = 0; i < data.length - win; i += hop) {',
  '    var s = 0; for (var j = 0; j < win; j++) s += data[i + j] * data[i + j]; energies.push(Math.sqrt(s / win));',
  '  } var thr = 0.028; for (var k = 2; k < energies.length; k++) {',
  '    if (energies[k] > energies[k-1] * 1.9 && energies[k] > thr) { onsets.push({time: (k * hop) / sr, intensity: energies[k]}); k += Math.floor(sr * 0.16 / hop); }',
  '  } return onsets;',
  '}',
  'function computeChroma(frame, sr) {',
  '  var chroma = new Float32Array(12);',
  '  var freqs = [16.35, 17.32, 18.35, 19.45, 20.60, 21.83, 23.12, 24.50, 25.96, 27.50, 29.14, 30.87];',
  '  for (var n = 0; n < 12; n++) { var noteE = 0; for (var oct = 2; oct < 7; oct++) {',
  '      var f = freqs[n] * Math.pow(2, oct); var omega = 2 * Math.PI * f / sr;',
  '      var s = 0, c = 0; for (var i = 0; i < frame.length; i++) { s += frame[i] * Math.sin(omega * i); c += frame[i] * Math.cos(omega * i); }',
  '      noteE += Math.sqrt(s * s + c * c);',
  '    } chroma[n] = noteE;',
  '  } var max = Math.max.apply(null, Array.from(chroma)) || 0.0001; return Array.from(chroma).map(function(v){ return v / max; });',
  '}',
  'self.onmessage = async function(e) {',
  '  var data = e.data || {}; var type = data.type; var payload = data.payload; var requestId = data.requestId;',
  '  if (!payload) return;',
  '  try {',
  '    if (type === "ANALYZE_FULL") {',
  '      var stu = new Float32Array(payload.stuData);',
  '      var ref = payload.refData ? new Float32Array(payload.refData) : null;',
  '      var sr = payload.sampleRate || 44100; var bpm = payload.targetBpm || 120;',
  '      var stuDetailedOnsets = detectOnsets(stu, sr);',
  '      var stuOnsets = stuDetailedOnsets.map(function(o){ return o.time; });',
  '      var stuIntensities = stuDetailedOnsets.map(function(o){ return o.intensity; });',
  '      var refOnsets = []; var refIntensities = [];',
  '      if (ref && ref.length > 0) { var d = detectOnsets(ref, sr); refOnsets = d.map(function(o){return o.time;}); refIntensities = d.map(function(o){return o.intensity;}); }',
  '      else if (bpm) { var secPerBeat = 60 / bpm; for(var t=0; t < (stu.length/sr); t += secPerBeat) { refOnsets.push(t); refIntensities.push(0.5); } }',
  '      var timingDev = stuOnsets.map(function(sT) {',
  '        if (refOnsets.length === 0) return 0;',
  '        var minD = Infinity; for(var i=0; i<refOnsets.length; i++) {',
  '          var d = (sT - refOnsets[i]) * 1000; if(Math.abs(d) < Math.abs(minD)) minD = d;',
  '        } return Math.abs(minD) < 600 ? minD : 0;',
  '      });',
  '      var stuEnv = []; for(var i=0; i<stu.length; i+=512) { var s=0; for(var j=0; j<512 && i+j<stu.length; j++) s+=stu[i+j]*stu[i+j]; stuEnv.push(Math.sqrt(s/512)); }',
  '      var refEnv = []; if (ref && ref.length > 0) { for(var i=0; i<ref.length; i+=512) { var s=0; for(var j=0; j<512 && i+j<ref.length; j++) s+=ref[i+j]*ref[i+j]; refEnv.push(Math.sqrt(s/512)); } }',
  '      else { for(var i=0; i<stuEnv.length; i++) refEnv.push(0.18); }',
  '      var sumSq = 0; var peak = 0; for(var x=0; x<stu.length; x++) { var a = Math.abs(stu[x]); sumSq += a*a; if(a > peak) peak = a; }',
  '      var avg = Math.sqrt(sumSq / (stu.length || 1)); var tr = Math.min(1.0, (peak / (avg + 0.01)) / 25.0);',
  '      var chrHist = []; for (var i = 0; i < stu.length - 2048; i += 4096) {',
  '        chrHist.push(computeChroma(stu.slice(i, i + 2048), sr));',
  '      }',
  '      self.postMessage({ type: "FULL_RESULT", requestId: requestId, payload: {',
  '        onset_count: stuOnsets.length, onsetTimesMs: stuOnsets.map(function(t){ return t * 1000; }),',
  '        onsetIntensities: stuIntensities, refOnsetTimesMs: refOnsets.map(function(t){ return t * 1000; }),',
  '        refOnsetIntensities: refIntensities, timingDeviationMs: timingDev, ',
  '        rms_db: 10 * Math.log10(sumSq / (stu.length || 1) + 1e-10), confidence: stuOnsets.length > 0 ? 0.9 : 0.1,',
  '        stability: calculateStability(stuOnsets), transient_ratio: tr,',
  '        stuEnvelope: stuEnv, refEnvelope: refEnv, chromaHistory: chrHist, sampleRate: sr',
  '      }});',
  '    }',
  '  } catch (err) { self.postMessage({ requestId: requestId, error: { message: err.message } }); }',
  '};'
].join('\n');